import React from 'react';
import { NavApp, initNavStore, PRODUCTS, type ENVIRONMENTS } from '@pulse/nav';
import InitCheck from './InitCheck';

const env = (BUILD_VARS.NODE_CONFIG_ENV || 'webappgcp') as ENVIRONMENTS;
initNavStore({ product: PRODUCTS.PATTERN_ANALYTICS, env });

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <NavApp />
      <InitCheck>{children}</InitCheck>
    </>
  );
};

export default Layout;
